function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import _ from "underscore";
import Radio from "./radio";
import BasicUtils from "../../utils/basic-utils";

var BooleanRadio = /*#__PURE__*/function (_React$Component) {
  _inherits(BooleanRadio, _React$Component);

  var _super = _createSuper(BooleanRadio);

  function BooleanRadio() {
    _classCallCheck(this, BooleanRadio);

    return _super.apply(this, arguments);
  }

  _createClass(BooleanRadio, [{
    key: "render",
    value: function render() {
      var _this = this;

      // radio group name needs to be unique because could be multiple boolean
      // radio groups in filters
      var name = BasicUtils.randomKey().toString();
      return /*#__PURE__*/React.createElement("fieldset", {
        className: classNames(this.props.className, "et--boolean-radio")
      }, /*#__PURE__*/React.createElement(Radio, {
        checked: this.props.value === true,
        disabled: this.props.disabled,
        onChange: function onChange() {
          return _this.props.onChange(_this.props.name, true);
        },
        name: name,
        label: this.props.trueLabel,
        value: true
      }), /*#__PURE__*/React.createElement(Radio, {
        checked: this.props.value === false,
        disabled: this.props.disabled,
        onChange: function onChange() {
          return _this.props.onChange(_this.props.name, false);
        },
        name: name,
        label: this.props.falseLabel,
        value: false
      }));
    }
  }]);

  return BooleanRadio;
}(React.Component);

_defineProperty(BooleanRadio, "propTypes", {
  name: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  trueLabel: PropTypes.string,
  falseLabel: PropTypes.string
});

_defineProperty(BooleanRadio, "defaultProps", {
  trueLabel: "Yes",
  falseLabel: "No",
  onChange: _.noop
});

export default BooleanRadio;